export function filterColumns(items: any) {
    let filterColumns: string[] = [];
    let item = items[0];

    if (item && item.item) {
        item = item.item
    }

    if (item) {
        for (let inc in item) {
            for (let i = 0; i < items.length; i++) {
                const value = items[i].item || items[i]
                if (typeof (value as any)[inc] === "string" && inc !== 'rowVersion' && inc !== 'id' && inc !== 'referenceId' && !inc.includes('ReferenceId')) {
                    if (items[i].item && inc.includes('destination')) {
                        inc = inc.replace('destination', 'writingDestination')
                    }
                    if (!filterColumns.includes(inc)) {
                        filterColumns.push(inc)
                    }
                    break;
                }
            }
            if (inc === 'businessNumber') {
                filterColumns = ['sourceCode', 'sourceDescription', 'destinationCode', 'destinationDescription'];
                break;
            }
        }
    }
    return filterColumns;
}


export function sort(items: any, sortColumn: string, sort: boolean, primaryList: any) {
    items.sort((a: any, b: any) => {
        let x = (sortColumn === 'parentNaic' || sortColumn === 'writingNaic') ? Number(a[sortColumn]) : a[sortColumn]
        let y = (sortColumn === 'parentNaic' || sortColumn === 'writingNaic') ? Number(b[sortColumn]) : b[sortColumn]
        if (sortColumn === 'isPrimary' && primaryList.length > 0) {
            y = primaryList.some((p: any) => p.destinationCode === a.destinationCode) && a.isPrimary && a.isMapped && !a.isDrop && a.isAddToMain ? 4 :
                primaryList.some((p: any) => p.destinationCode === a.destinationCode) && !a.isPrimary && a.isMapped && !a.isDrop && a.isAddToMain ? 3 :
                !a.isAddToMain && a.isMapped && !a.isDrop ? 2 : 1;
            x = primaryList.some((p: any) => p.destinationCode === b.destinationCode) && b.isPrimary && b.isMapped && !b.isDrop && a.isAddToMain ? 4 :
                primaryList.some((p: any) => p.destinationCode === b.destinationCode) && b.isPrimary && b.isMapped && !b.isDrop && a.isAddToMain ? 3:
                !a.isAddToMain && b.isMapped && !b.isDrop ? 2 : 1;
        }
        //if (sortColumn === 'parentIsPrimary' && primaryList.length > 0) {
        //    y = primaryList.some((p: any) => p.parentDestinationCode === a.parentDestinationCode) && a.parentIsPrimary && !a.parentReferenceId && primaryList.some((p: any) => p.destinationCode === a.destinationCode) && a.isPrimary && !a.referenceId && a.isMapped && !a.isDrop ? 5
        //        : primaryList.some((p: any) => p.destinationCode === a.destinationCode) && a.isPrimary && !a.referenceId && a.isMapped && !a.isDrop ? 4
        //         : primaryList.some((p: any) => p.parentDestinationCode === a.parentDestinationCode) && !a.parentIsPrimary && !a.parentReferenceId && primaryList.some((p: any) => p.destinationCode === a.destinationCode) && a.isPrimary && !a.referenceId && a.isMapped && !a.isDrop ? 3
        //                : primaryList.some((p: any) => p.destinationCode === a.destinationCode) && !a.isPrimary && !a.referenceId && a.isMapped && !a.isDrop ? 2 : 1;
        //    x = primaryList.some((p: any) => p.parentDestinationCode === b.parentDestinationCode) && b.parentIsPrimary && !b.parentReferenceId && primaryList.some((p: any) => p.destinationCode === b.destinationCode) && b.isPrimary && !b.referenceId && b.isMapped && !b.isDrop ? 5
        //        : primaryList.some((p: any) => p.destinationCode === b.destinationCode) && b.isPrimary && !b.referenceId && b.isMapped && !b.isDrop ? 4
        //        : primaryList.some((p: any) => p.parentDestinationCode === b.parentDestinationCode) && !b.parentIsPrimary && !b.parentReferenceId && primaryList.some((p: any) => p.destinationCode === b.destinationCode) && b.isPrimary && !b.referenceId && b.isMapped && !b.isDrop ? 3
        //                : primaryList.some((p: any) => p.destinationCode === b.destinationCode) && !b.isPrimary && !b.referenceId && b.isMapped && !b.isDrop ? 2 : 1;
        //}
        if (typeof y === "string" && typeof x === "string") {
            y = y.toLowerCase().trim()
            x = x.toLowerCase().trim()
        }
        if (x === y) {
            return 0;
        }
        else if (x === null) {
            return 1;
        }
        else if (y === null) {
            return -1;
        }
        else if (sort) {
            return x < y ? -1 : 1;
        }
        else {
            return x < y ? 1 : -1;
        }
    })
    return items
}